export default function FilesIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path fill="#F2F6FC" d="M1.563 14.688h5.625v1.874H1.563v-1.875Z" />
        <path fill="#CDD2E1" d="M1.563 15.625h5.625v.938H1.563v-.938Z" />
        <path fill="#65B1FC" d="M10.313 2.188h9.374v12.187h-9.375V2.187Z" />
        <path
          fill="#4A98F7"
          d="M10.313 3.438h6.25a1.25 1.25 0 0 1 1.25 1.25v9.687h-7.5V3.437Z"
        />
        <path fill="#F2F6FC" d="M7.188 4.375h9.375v12.188H7.188V4.374Z" />
        <path
          fill="#CDD2E1"
          d="M7.188 7.188h5.625a1.563 1.563 0 0 1 1.562 1.562v7.813H7.187V7.188Z"
        />
        <path
          fill="#FFA426"
          d="M7.188 6.875v1.25h-.625L5 6.562H1.562v-1.25h4.063l1.563 1.563Z"
        />
        <path
          fill="#FE8205"
          d="M5 5.938H1.562v.625H5l1.563 1.562h.625V7.5h-.625L5 5.937Z"
        />
        <path
          fill="#FFC247"
          d="M13.438 9.375v7.188a1.25 1.25 0 0 1-1.25 1.25H1.562a1.25 1.25 0 0 1-1.25-1.25v-10H5l1.563 1.562h5.625a1.25 1.25 0 0 1 1.25 1.25Zm-6.25 7.188v-1.875H1.563v1.874h5.625Z"
        />
        <path
          fill="#FFA426"
          d="M1.563 16.563v-10H.313v10a1.25 1.25 0 0 0 1.25 1.25h1.25a1.25 1.25 0 0 1-1.25-1.25Zm5.625-1.875h1.25v1.874h-1.25v-1.875Z"
        />
        <path
          fill="#11A892"
          d="M8.125 5.313h.625v.625h-.625v-.625Zm1.25 0h2.5v.625h-2.5v-.625Zm-1.25 1.25h7.5v.625h-7.5v-.625ZM2.5 15.313h.625v.624H2.5v-.624Zm1.25 0h2.5v.624h-2.5v-.624Z"
        />
        <path
          fill="#000"
          d="M19.688 1.875h-9.375a.313.313 0 0 0-.313.313v1.874H7.187a.312.312 0 0 0-.312.313v1.746l-1.03-1.03A.313.313 0 0 0 5.626 5H1.562a.312.312 0 0 0-.312.313v.937H.312A.312.312 0 0 0 0 6.563v10a1.564 1.564 0 0 0 1.563 1.562h10.624a1.565 1.565 0 0 0 1.532-1.25h2.844a.313.313 0 0 0 .312-.313v-1.875h2.813a.313.313 0 0 0 .312-.312V2.187a.312.312 0 0 0-.313-.312ZM1.875 5.625h3.62l1.38 1.38v.807h-.183L5.22 6.343A.313.313 0 0 0 5 6.25H1.875v-.625Zm11.25 10.938a.938.938 0 0 1-.938.937H1.563a.938.938 0 0 1-.938-.938V6.876h4.246l1.47 1.47a.313.313 0 0 0 .222.092h5.625a.937.937 0 0 1 .937.938v7.188Zm3.125-.313h-2.5V9.375a1.564 1.564 0 0 0-1.563-1.563H7.5V4.688h8.75V16.25Zm3.125-2.188h-2.5V4.376a.312.312 0 0 0-.313-.313h-5.937V2.5h8.75v11.563Z"
        />
        <path
          fill="#000"
          d="M8.125 5.313h.625v.625h-.625v-.625Zm1.25 0h2.5v.625h-2.5v-.625Zm-1.25 1.25h7.5v.625h-7.5v-.625Zm-.938 7.812H1.563a.312.312 0 0 0-.312.313v1.874a.313.313 0 0 0 .313.313h5.625a.312.312 0 0 0 .312-.313v-1.875a.313.313 0 0 0-.313-.312Zm-.312 1.875h-5V15h5v1.25Z"
        />
        <path
          fill="#000"
          d="M2.5 15.313h.625v.624H2.5v-.624Zm1.25 0h2.5v.624h-2.5v-.624Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
